import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import SectionUs4 from "./page_us/solution-US-4/Section-Us-4.js";
import { useEffect } from "react";



const US_STORE_BANNE = () =>{
    
useEffect(() => {
  // ========= HELPERS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= TITLE =========
  document.title =
    "Store Banne Maroc | Terrasse & Protection Solaire – UNIK SYSTEM";

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Store banne au Maroc avec UNIK SYSTEM : stores extérieurs pour terrasse, protection solaire efficace, confort thermique et design moderne pour villas, cafés et restaurants."
  );

  setMeta(
    "keywords",
    "store banne maroc, store terrasse maroc, store exterieur maroc, store retractable maroc, store banne motorise maroc, store solaire terrasse maroc, UNIK SYSTEM store banne"
  );

  setMeta("robots", "index, follow");
  setMeta("author", "UNIK SYSTEM");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute(
    "href",
    "https://unik-system.com/store-banne-maroc"
  );

  // ========= IMAGE =========
  const imageUrl =
    "https://unik-system.com/static/media/18Store%20banne%20motoris%C3%A9%20pour%20terrasse%20de%20villa%20moderne%20avec%20piscine%20%E2%80%93%20solution%20protection%20solaire%20UNIK%20SYSTEM.33626261c1b2a631a969.webp";

  // ========= OPEN GRAPH =========
  setMetaProperty(
    "og:title",
    "Store Banne Maroc – Terrasse & Protection Solaire | UNIK SYSTEM"
  );
  setMetaProperty(
    "og:description",
    "Stores bannes design pour terrasse avec protection solaire et confort thermique."
  );
  setMetaProperty("og:image", imageUrl);
  setMetaProperty(
    "og:url",
    "https://unik-system.com/store-banne-maroc"
  );
  setMetaProperty("og:type", "website");
  setMetaProperty("og:locale", "fr_FR");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta(
    "twitter:title",
    "Store Banne Maroc – UNIK SYSTEM"
  );
  setMeta(
    "twitter:description",
    "Solution idéale pour terrasse avec protection solaire moderne."
  );
  setMeta("twitter:image", imageUrl);

  // ========= SCHEMA (SERVICE EXTERIEUR) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "UNIK SYSTEM",
    url: "https://unik-system.com",
    description:
      "Spécialiste en stores bannes et protection solaire extérieure au Maroc.",
    address: {
      "@type": "PostalAddress",
      addressCountry: "MA",
    },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Stores Extérieurs",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Store Banne Terrasse"
          }
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Store Banne Motorisé"
          }
        }
      ]
    }
  };

  let script = document.querySelector("#schema-us-store-banne");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-store-banne";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

  // ========= FAQ SCHEMA =========
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "C’est quoi un store banne ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "C’est un store extérieur rétractable utilisé pour protéger une terrasse du soleil."
        }
      },
      {
        "@type": "Question",
        name: "Quels sont les avantages ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Protection solaire, réduction de chaleur, confort extérieur et design moderne."
        }
      },
      {
        "@type": "Question",
        name: "Pour quels espaces ?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Terrasses, cafés, restaurants, villas et espaces extérieurs."
        }
      }
    ]
  };

  let faqScript = document.querySelector("#faq-schema-us-store-banne");
  if (!faqScript) {
    faqScript = document.createElement("script");
    faqScript.type = "application/ld+json";
    faqScript.id = "faq-schema-us-store-banne";
    document.head.appendChild(faqScript);
  }
  faqScript.innerHTML = JSON.stringify(faqSchema);

}, []);




  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs4/>
            <Footer/>
        </div>    
    )
};

export default US_STORE_BANNE;